const fmt = require("indian-number-format");

export default function TotalCard({
  nse_cash = 0,
  pl = 0,
  deposit_wallet = 0,
  withdraw_wallet = 0,
  deposit = 0,
  credit = 0,
  withdraw = 0,
}) {
  const userType = Number(localStorage.getItem("user_type") || 7);

  /** ------------------ HELPERS ------------------ **/
  const safeNumber = (val) => {
    const num = parseFloat(val);
    return isNaN(num) ? 0 : num;
  };

  /** ------------------ CARD STYLE ------------------ **/
  const cardStyle = {
    minWidth: "120px",
    padding: "6px 12px",
    borderRadius: "8px",
    background: "var(--background)",
    border: "2px solid var(--hover)",
    color: "var(--text)",
    display: "flex",
    flexDirection: "column",
  };

  const labelStyle = {
    fontSize: "0.7rem",
    opacity: 0.7,
    fontWeight: 500,
  };

  const valueStyle = {
    fontSize: "1rem",
    fontWeight: 700,
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
        padding: "10px 20px",
        background: "var(--background)",
        color: "var(--text)",
        borderBottom: "1px solid var(--hover)",
      }}
    >
      {/* WALLET DEPOSIT */}
      {safeNumber(deposit_wallet) > 0 && userType === 4 && (
        <div style={cardStyle}>
          <span style={labelStyle}>WALLET DEPOSIT</span>
          <span style={{ ...valueStyle, color: "var(--buy)" }}>
            {fmt.format(safeNumber(deposit_wallet).toFixed(0))}
          </span>
        </div>
      )}

      {/* DEPOSIT */}
      {userType === 4 && (
        <div style={cardStyle}>
          <span style={labelStyle}>DEPOSIT</span>
          <span style={{ ...valueStyle, color: "var(--buy)" }}>
            {fmt.format(safeNumber(deposit).toFixed(0))}
          </span>
        </div>
      )}

      {/* ACCOUNT P&L */}
      <div style={cardStyle}>
        <span style={labelStyle}>ACCOUNT P&L</span>
        <span
          style={{
            ...valueStyle,
            color: safeNumber(pl) >= 0 ? "var(--buy)" : "var(--sell)",
          }}
        >
          {fmt.format(safeNumber(pl).toFixed(0))}
        </span>
      </div>

      {/* WALLET WITHDRAW */}
      {safeNumber(withdraw_wallet) > 0 && userType === 4 && (
        <div style={cardStyle}>
          <span style={labelStyle}>WALLET WITHDRAW</span>
          <span style={{ ...valueStyle, color: "var(--sell)" }}>
            {fmt.format(safeNumber(withdraw_wallet).toFixed(0))}
          </span>
        </div>
      )}

      {/* WITHDRAW */}
      {userType === 4 && (
        <div style={cardStyle}>
          <span style={labelStyle}>WITHDRAW</span>
          <span style={{ ...valueStyle, color: "var(--sell)" }}>
            {fmt.format(safeNumber(withdraw).toFixed(0))}
          </span>
        </div>
      )}

      {/* CASH DEPOSIT (NSE CASH) */}
      {nse_cash === 1 && safeNumber(credit) > 0 && userType === 4 && (
        <div style={cardStyle}>
          <span style={labelStyle}>CASH DEPOSIT</span>
          <span style={{ ...valueStyle, color: "var(--buy)" }}>
            {fmt.format(safeNumber(credit).toFixed(0))}
          </span>
        </div>
      )}
    </div>
  );
}
